// @ts-check
import { Appsettings } from "../Appsettings";
import StudyItem from "../models/studies/list";
import Study from "../models/studies/study";
import StudyReport from "../models/studies/report";
import { VerifyJWT } from "../utils/jwtTools";

/**
 * @param {string} startDate
 * @param {string} endDate
 * @returns {Promise<StudyItem[]>}
 */
export async function getStudiesByDateRange(startDate, endDate) {
  //const url = path.join(
  //  Appsettings.ApiUrl,
  //  `getestudios?inicio=${startDate}&final=${endDate}`,
  //);
  const url = Appsettings.ApiUrl + "/getestudios?inicio=" + startDate + "&final=" + endDate;
  const req = await fetch(url);
  if (!req.ok) {
    throw new Error("Error al obtener los estudios");
  }
  const res = await req.json();
  // @ts-ignore
  const list = res.map((item) => new StudyItem(item));
  return list;
}

/**
 * @param {Object} data
 * @returns {Promise<Object>}
 */
export async function ShareMail(data) {
  //const url = path.join(Appsettings.ApiUrl, `sharecorreo`);
  const url = Appsettings.ApiUrl + "/sharecorreo";
  const req = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  if (!req.ok) {
    throw new Error("Error al enviar el correo");
  }
  const res = await req.json();
  return res;
}

/**
 *
 */

/**
 * @param {number} ID
 * @returns {Promise<StudyReport>}
 */
export async function getInformeByID(ID) {
  //const url = path.join(Appsettings.ApiUrl, `existeinforme`, `${ID}`);
  const url = Appsettings.ApiUrl + "/existeinforme/" + ID;
  const req = await fetch(url);
  if (!req.ok) {
    throw new Error("Error al obtener el informe");
  }
  const res = await req.json();
  return new StudyReport(res);
}

/**
 * @param {string} fileuuid
 * @returns {Promise<Blob>}
 */
export async function getDicomFile(fileuuid) {
  //const url = path.join(Appsettings.ApiUrl, `getfiles`, `${fileuuid}`);
  const url = Appsettings.ApiUrl + "/getfiles/" + fileuuid;
  const req = await fetch(url);
  if (!req.ok) {
    throw new Error("Error al obtener el informe");
  }
  const res = await req.blob();
  return res;
}

/**
 * @param {number} ID
 * @returns {Promise<Study>}
 */
export async function getStudyByID(ID) {
  //const url = path.join(Appsettings.ApiUrl, `study`, `${ID}`);
  const url = Appsettings.ApiUrl + "/study/" + ID;
  const req = await fetch(url);
  if (!req.ok) {
    throw new Error("Error al obtener el estudio");
  }
  const res = await req.json();
  return new Study(res);
}

/**
 * @param {string} token
 * @returns {Promise<Study>}
 */
export async function getStudyByToken(token) {
  try {
    const payload = VerifyJWT(token);
    if (!payload) {
      throw new Error("Token invalido");
    }
    // @ts-ignore
    //const url = path.join(Appsettings.ApiUrl, `study`, `${payload.ID}`);
    const url = Appsettings.ApiUrl + "/study/" + payload.ID;
    const req = await fetch(url);
    if (!req.ok) {
      throw new Error("Error al obtener el estudio");
    }
    const res = await req.json();
    return new Study(res);
  } catch (error) {
    throw error;
  }
}

/**
 * @param {string} nombre
 * @returns {Promise<Blob>}
 */
export async function getReportFile(nombre) {
  //const url = path.join(Appsettings.ApiUrl, `descargarinformever`, `${nombre}`);
  const url = Appsettings.ApiUrl + "/descargarinformever/" + nombre;
  const req = await fetch(url);
  if (!req.ok) {
    throw new Error("Error al obtener el archivo del informe");
  }
  const res = await req.blob();
  return res;
}

export default {
  getStudiesByDateRange,
  ShareMail,
  getInformeByID,
  getDicomFile,
  getStudyByID,
  getReportFile,
};
